<template>
	<div class="new-room-form">
		<ModalHeader :title="getString('room_creation')" :button-text="buttonTitle" @clickButton="addRoom" :button-disabled="disabledContinueButton" />
		<div class="mini-card" v-if="currentStep === 0">
			<div class="mini-header"><p>{{ getString('room_settings') }}</p></div>
			<div class="mini-body">
				<AppList :items="roomSettings" />
			</div>
		</div>
		<AddElements @elements-changed="changedElements" ref="add-elements" v-else-if="currentStep === 1" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppList from "@/shared/components/AppList.vue";
import {useUserStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AddElements from "@/console-new/components/config/qrcode/AddElements.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, notificationStore, userStore};
	},
	name: "NewRoomForm",
	emits: ["created"],
	components: {AppButtonIcon, AppList, ModalHeader, AddElements},
	data() {
		return {
			roomName: '',
			roomAcceptOrders: true,
			currentStep: 0,
			addingElements: [],
		}
	},
	computed: {
		disabledContinueButton() {
			if(this.currentStep === 1) {
				return !this.addingElements?.length
			}
			return false;
		},
		roomSettings() {
			return [
				{title: this.getString('room_name'), explain: this.getString('room_name_explain'), textInput: true, placeholder: this.getString('room_name'), value: this.roomName, callbackText: (v) => this.roomName = v},
				{title: this.getString('allow_orders'), switch: true, active: this.roomAcceptOrders, callback: (v) => this.roomAcceptOrders = v}
			];
		},
		buttonTitle() {
			return this.currentStep === 0 ? this.getString('next') : this.getString('create');
		}
	},
	methods: {
		changedElements(elements) {
			this.addingElements = elements ? elements : [];
		},
		addRoom() {

			if(this.roomName.length === 0) {
				this.notificationStore.showNotification('invalid-name');
				return;
			}

			if(this.currentStep === 0) {
				this.currentStep = 1;
				return;
			}

			if(!this.$refs['add-elements']) {
				this.notificationStore.showNotification('generic-fail');
				return;
			}
			let elements = this.addingElements;

			let elementsNumber = elements.reduce((acc, element) => acc + ((Math.abs(element.to - element.from)) + 1), 0);
			if(elementsNumber <= 0) {
				this.notificationStore.showNotification('no-elements-error');
				return;
			}
			if(elementsNumber > 200) {
				this.notificationStore.showNotification('too-many-elements-error');
				return;
			}

			API.init().addRoom(this.userStore.currBusinessId, this.roomName, this.roomAcceptOrders, false, JSON.stringify(elements), (response) => {
				if(response && response.result && response.result === "OK") {
					this.$emit('created', response.room_id ? Number(response.room_id) : null);
					this.notificationStore.showNotification('generic-success');
				} else {
					this.notificationStore.showNotification('generic-fail');
				}
			});

		},

	}
}
</script>

<style scoped lang="scss">
.mini-card {
	display: flex;
	flex-direction: column;
	border-radius: 13px;
	background: var(--color-bg-primary-1);
	box-shadow: 0 2px 3px 0 var(--color-alpha-2) inset;

	.mini-header {
		border-radius: 13px 13px 0 0;
		border-bottom: 1px solid var(--color-alpha-4);
		background: var(--color-bg-primary-2);
		padding: 10px;

		p {
			font-weight: bold;
			font-size: 18px;
			text-align: center;
		}
	}

	.mini-body {
		padding: 10px;
	}
}
</style>